import styled from 'styled-components';
import {downWithOrientation} from 'epic-ue-components';

export const Contact = styled.div`
    min-height: 540px;
    ${(p) => p.theme.breakpoints.down('sm')} {
        min-height: initial;
    }
    background: ${(p) => p.theme.palette.background.default};
    color: ${(p) => p.theme.palette.text.primary};

    .heading {
        opacity: 0;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        transition: opacity 800ms ease-out;
        ${(p) => p.theme.breakpoints.down('sm')} {
            top: 0;
            transform: initial;
            min-height: initial;
            padding: 2em 1em;
        }
    }

    &.runAnimation {
        .heading {
            opacity: 1;
        }
        .cta,
        .newsletter {
            transform: translateX(0);
        }
    }

    > * {
        text-align: center;
    }

    overflow: hidden;
`;

export const EngamementSection = styled.div`
    ${(p) => p.theme.breakpoints.down('sm')} {
        height: auto;
    }
    min-height: 540px;
    width: 100%;
    max-width: 560px;

    .heading {
        margin-bottom: 0.5em;
    }

    .overlay {
        backdrop-filter: initial !important;
    }

    form {
        max-width: 500px;
        margin: 0 auto;
    }

    h1 {
        font-size: 2.6em;
        margin-top: 0.5em;
        color: ${(p) => p.theme.palette.common.white};
    }

    h2 {
        font-size: 2em;
        margin-top: 0.3em;
        color: ${(p) => p.theme.palette.common.white};
    }

    p.top {
        margin: 0 auto 10px;
    }

    .btn.btn-primary {
        line-height: initial;
    }

    .form {
        input,
        select {
            color: ${(p) => p.theme.palette.common.white};
            option {
                color: black;
            }
        }
        .select-div {
            &:after {
                background: none !important;
            }
            .chevron {
                border-top-color: #f5f5f5 !important;
            }
            select {
                background: none;
            }
        }
    }
    .card.overlay.handheld {
        ${(p) => p.theme.breakpoints.down('xs')} {
            max-width: 100%;
            border-radius: 0;
            height: 100%;
            h2 {
                font-size: 1.4em;
            }
            .legal-row p {
                font-size: 11px;
                line-height: 13px;
            }
            .card-content {
                padding: 13px;
            }
        }
    }

    .card-section {
        ${(p) => p.theme.breakpoints.down('xs')} {
            height: 60vh;
        }

        ${downWithOrientation('lg', 'landscape')} {
            height: 100vh;
        }
    }
`;

export const Section = styled.div`
    height: 540px;
    width: 50%;
    display: inline-block;
    transition: opacity 800ms ease-out, transform 600ms ease-out;

    .engage-section-border {
        height: 100%;
        width: 100%;
        max-width: 560px;
        display: inline-block;
        border: 2px solid ${(p) => p.theme.palette.primary.main};
        padding: 0 30px;
        ${(p) => p.theme.breakpoints.down('md')} {
            padding: 0 15px;
        }
    }

    ${(p) => p.theme.breakpoints.down('lg')} {
        padding: 30px 50px;
    }
    ${(p) => p.theme.breakpoints.down('md')} {
        padding: 15px 35px;
    }
    ${(p) => p.theme.breakpoints.down('sm')} {
        height: auto;
        padding: 15px 15px;
        float: none;
        width: 100%;
    }

    padding: 30px 70px;
    h1 {
        font-size: 2.6em;
        font-family: ${(p) => p.theme.ue.fonts.brutal.light};
        margin-top: 0;
        margin-bottom: 10px;
        ${(p) => p.theme.breakpoints.down('md')} {
            font-size: 2em;
        }
    }
    h2 {
        font-size: 1.2em;
        font-family: ${(p) => p.theme.ue.fonts.brutal.light};
        margin-bottom: 10px;
        margin-top: 18px;
        ${(p) => p.theme.breakpoints.down('sm')} {
            font-size: 1em;
        }
    }
    p {
        max-width: 70%;
        margin: 4px auto;
        line-height: 1.3em;
        ${(p) => p.theme.breakpoints.down('sm')} {
            max-width: 100%;
        }
    }
    form {
        max-width: 500px;
        margin: 0 auto;
    }
    p.top {
        margin: 0 auto 10px;
    }
    p.bottom {
        margin-bottom: 0;
    }
    &.cta.full-width,
    &.newsletter.full-width {
        width: 100%;
        float: none;
    }
    &.cta {
        float: left;
        transform: translateX(-15%);
        .btn {
            margin-top: 2em;
            margin-bottom: 2em;
        }
        ${(p) => p.theme.breakpoints.down('sm')} {
            float: none;
        }
    }
    &.newsletter {
        float: right;
        transform: translateX(15%);
        ${(p) => p.theme.breakpoints.down('sm')} {
            float: none;
        }
    }
`;
